export enum UserPatientRelationshipType {
  Self = 1,
  Spouse = 2,
  Parent = 3,
  Child = 4,
  Guardian = 5,
  POA = 6,
  Caregiver = 7,
  Other = 8,
}
